import { render, staticRenderFns } from "./pwdLogin.vue?vue&type=template&id=4ea455e6&scoped=true&"
import script from "./pwdLogin.vue?vue&type=script&lang=js&"
export * from "./pwdLogin.vue?vue&type=script&lang=js&"
import style0 from "./pwdLogin.vue?vue&type=style&index=0&id=4ea455e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea455e6",
  null
  
)

export default component.exports